import React from "react";
import imagesLogo from "../../assets/images/logo-toyota.jpeg";

function Header() {
  return (
    <header className="w3l-header-nav">
      <nav className="navbar navbar-expand-lg navbar-light px-lg-0 py-0 px-3 stroke">
        <div className="container">
          {/* <h1><a className="navbar-brand" href="index.html">Drifter<span>z</span></a></h1>  */}
          {/* if logo is image enable this     */}
          {/* <a className="navbar-brand" href="/">
            <img
              src="assets/images/logo-toyota.jpeg"
              alt="Your logo"
              title="Your logo"
              style="height:50px;"
            />
          </a> */}
          <a className="navbar-brand" href="/">
            <img src={imagesLogo} alt="Your logo" title="Your logo" />
          </a>

          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="fa icon-expand fa-bars"></span>
            <span className="fa icon-close fa-times"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="tel:0866866501">
                  <span className="fa fa-phone mr-2"></span>0866 866 501
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="mailto:truonggiang@gmail.com">
                  <span className="fa fa-envelope mr-2"></span>
                  <span style={{ textTransform: "none" }}>
                    truonggiang@gmail.com
                  </span>
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="tel:0866866501">
                  Hotline Hỗ trợ tài chính: 0866 866 501
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
